export interface FolderSuggestion {
  name: string;
  icon: string;
}

export const FOLDER_SUGGESTIONS: FolderSuggestion[] = [
  { name: 'Meetings', icon: 'Users' },
  { name: 'Classes', icon: 'GraduationCap' },
  { name: 'Imports', icon: 'FileText' },
  { name: 'Recordings', icon: 'Video' },
  { name: 'Podcasts', icon: 'Podcast' },
  { name: 'Interviews', icon: 'Mic2' },
  { name: 'Presentations', icon: 'Layout' },
  { name: 'Projects', icon: 'Briefcase' },
  { name: 'Research', icon: 'Microscope' },
  { name: 'Personal', icon: 'Home' },
];
